import React from "react";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import { CSSTransition } from "react-transition-group";

const useStyles = makeStyles((theme) =>
    createStyles({
        overlayLoading: {
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.6)",
            bottom: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
        },
    })
);

export default function OverlayLoading(props) {
    const classes = useStyles();
    return (
        <CSSTransition
            in={props.loading}
            timeout={1000}
            classNames="fade-animation"
            unmountOnExit
            appear
            key="login-loading"
        >
            <div className={classes.overlayLoading}>
                <CircularProgress />
            </div>
        </CSSTransition>
    );
}
